module.exports = __webpack_public_path__ + "img/AromaEmpress.12413295.png";